<style lang="scss" scoped>
  .chart-component {

    .chart-alert,
    .chart-loading {
      padding: 12px;
      text-align: center;
      h4 {
        font-size: 18px;
        line-height: 30px;
        font-weight: 300;
      }
    }

    .chart-loading {
      h4 {
        font-weight: 300;
      }
    }

    .table-title {
      color:#71767D;
      font-size: 20px;
      font-weight: 600;
      border: 0;
      padding:16px 16px 32px 16px;
      font-family: 'Montserrat';
    }

    tbody {
      tr {
        border-bottom: 1px solid #dee2e6;
        font-size: 12px;
        font-weight: 400;
        letter-spacing: -0.18px;

        .item-line {
          color: #857a98;
          font-weight: 700;
        }

        .item-label {
          color: #3b334a;
        }

        td {
          border: 0;
          padding: 15px 0;
        }
      }
    }

    tfoot td {
      font-weight: 700;
      font-size: 12px;
      letter-spacing: -0.18px;
      padding: 15px 0;
      border: 0;

      &:nth-child(2) {
        color: #857a98;
      }
    }

    #summary-table {
        background-color: transparent;
    }

    table thead th {
        text-transform: none;
        color: #3b334a;
        font-size: 18px;
        font-weight: 400;
        letter-spacing: -0.27px;
        line-height: 30px;

        height: 30px;
        padding-top: 25px;
    }
  }
</style>

<template>
  <div
    class="chart-component"
    v-show="loading || fetched.data.total || alert"
  >
    <div
      class="chart-loading"
      v-show="loading"
    >
      <h4><i class="fa fa-circle-o-notch fa-spin" /></h4>
    </div>
    <div
      class="chart-alert"
      v-show="!show && !loading"
    >
      <!-- <h4>Nenhum dado encontrado no período</h4> -->
    </div>
    <div v-show="show">
      <table id="summary-table" class="table">
        <thead>
          <tr>
            <th
              colspan="2"
              class="text-center table-title"
            >
              {{ __('Resumo') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in lines">
            <td v-if="item.label">
              {{ formatLabel(item.label) }}
            </td>
            <td class="item-label">
              {{ __(item.line) }}
            </td>
            <td class="item-line text-right">
              {{ formatTotal(item.total) }}
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="total">
            <td :colspan="hasLabel ? 2 : 1">
              {{ __('Total') }}
            </td>
            <td class="text-right">
              {{ formatTotal(fetched.data.total) }}
            </td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
import String from '../../services/strings';
import dayjs from '../../core/dayjs';
import { currencyFormat } from '../../helpers/currencyFormat';
import { percentFormat } from '../../helpers/percentFormat';
import { setNewObjectToTable } from '../../helpers/setNewObjectToTable';

export default {
  async mounted () {
    await this.fetch();
    this.$watch('range', () => this.fetch());
    this.$watch('timeperiod', async (timeperiod) => {
      await this.fetch();
      switch (timeperiod) {
        case 'month':
          this.format = 'MM/YYYY';
          break;
        case 'year':
          this.format = 'YYYY';
          break;
        default:
          this.format = 'D/MM/YY';
          break;
      }
    });
    this.$watch('deselectedData', async (newData, oldData) => {
      if (newData !== oldData) {
        this.fetch();
      }
    }, {deep: true});
  },
  props: ['height', 'width', 'range', 'source', 'timeseries', 'timeperiod', 'alert', 'legend', 'rotated', 'deselectedData'],
  data () {
    return {
      loading: false,
      fetched: {
        data: {
          total: 0,
        },
      },
    };
  },

  computed: {
    show () {
      return this.loading === false && this.fetched.data.total;
    },

    hasLabel () {
      let result = false;

      this.fetched
          && this.fetched.data
          && this.fetched.data.lines
          && this.fetched.data.lines.forEach((item) => {
            result = result || item.label;
          });

      return !! result;
    },

    lines () {
      if (! (this.fetched && this.fetched.data && this.fetched.data.lines)) {
        return [];
      }

      return this.fetched.data.lines;
    },
  },

  methods: {
    formatLabel (label) {
      if (String.isIsoDate(label)) {
        return dayjs(new Date(label)).format('LD');
      }

      return label;
    },

    formatTotal (total) {
      if (! total) {
        return '-';
      }

      if (this.type === 'avg') {
        total /= this.fetched.data.count;
      }

      if (this.fetched.options.chart.currency) {
        return currencyFormat(total);
      }

      if (this.fetched.options.chart.percentage) {
        return percentFormat(total, 1);
      }

      return total;
    },

    async fetch () {
      this.loading = true;

      const params = {
        range: this.range,
        // timeseries: this.timeseries ? 1 : 0,
        timeseries: 0,
        timeperiod: this.timeperiod,
      };

      this.$http.get(`/report/source/${this.source}/table`, { params })
        .then((response) => {
          this.fetched = response.data
          // console.log('Summary got this.deselectedData => ', this.deselectedData);
          // console.log('Summary fetched data => ', this.fetched);
          if (this.deselectedData?.length > 0) {
            this.fetched = setNewObjectToTable( this.fetched, this.deselectedData);
          }
          this.loading = false;
        })
        .catch(error => {
          console.error("Failed to fetch data:", error);
          this.isFetchingData = false;
        });
    },
  },
};
</script>
